/**
 * Allowed profil names when a Manager creates a teammate.
 * ADMIN and DENDROMAP are intentionally excluded.
 */
export const ALLOWED_TEAMMATE_PROFIL_NAMES: readonly string[] = ['MANAGER', 'AGENT', 'VISITEUR'];

/**
 * Returns true when `profilName` is one of the three teammate-level profiles
 * (case-insensitive). Returns false for ADMIN, DENDROMAP, null, or undefined.
 */
export function isAllowedTeammateProfilName(profilName: string | null | undefined): boolean {
  if (!profilName) return false;
  return ALLOWED_TEAMMATE_PROFIL_NAMES.includes(profilName.toUpperCase());
}
